// ADR 0001 §5 - access JWT lives ONLY in memory, never in a cookie or localStorage.
import decode from "jwt-decode"

let _token = null

export const accessToken = {
  get() {
    return _token
  },
  set(token) {
    _token = token
  },
  clear() {
    _token = null
  },
  decoded() {
    if (!_token) return null
    try {
      return decode(_token)
    } catch {
      return null
    }
  },
  isExpired() {
    const payload = this.decoded()
    if (!payload) return true
    return payload.exp * 1000 < Date.now()
  },
}

export default accessToken
